import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Eye, EyeOff, Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async () => {
    setLoading(true);
    try {
      const r = await api.post("/auth/admin/login", { login, senha });
      window.location.href = "/admin";
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm text-center">
        <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="h-24 w-auto object-contain mx-auto mb-5 rounded-xl bg-white p-1.5" />
        <div className="flex items-center justify-center gap-2 mb-1">
          <Lock className="w-5 h-5 text-[#F5B301]" />
          <h1 className="font-heading text-2xl font-bold text-white">Painel de Gestão</h1>
        </div>
        <p className="text-slate-400 text-xs mb-6">Acesso restrito à administração · carlosjrfretesemudancas.com.br</p>

        <input
          data-testid="admin-login-input"
          className="w-full px-4 py-3.5 rounded-xl mb-3 text-sm"
          placeholder="Login"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          autoComplete="username"
        />
        <div className="relative mb-4">
          <input
            data-testid="admin-senha-input"
            type={show ? "text" : "password"}
            className="w-full px-4 py-3.5 rounded-xl text-sm pr-12"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password"
            onKeyDown={(e) => e.key === "Enter" && login && senha && !loading && submit()}
          />
          <button
            type="button"
            data-testid="admin-senha-toggle"
            onClick={() => setShow((s) => !s)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-navy"
          >
            {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        <button
          data-testid="admin-entrar-btn"
          onClick={submit}
          disabled={loading || !login || !senha}
          className="w-full py-4 rounded-2xl bg-[#F5B301] text-navy font-heading font-extrabold text-sm active:scale-95 transition-transform disabled:opacity-60"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : "ENTRAR"}
        </button>
        <Link to="/admin/recuperar-senha" className="block mt-3 text-[11px] text-[#F5B301] underline" data-testid="admin-esqueci-senha-link">
          Esqueci minha senha
        </Link>

        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-white/15" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500">ou</span>
          <div className="flex-1 h-px bg-white/15" />
        </div>

        <button
          data-testid="admin-google-btn"
          onClick={googleLogin}
          className="w-full py-3.5 rounded-2xl bg-white text-navy font-heading font-bold text-sm active:scale-95 transition-transform"
        >
          ENTRAR COM GOOGLE
        </button>

        <Link to="/" className="block mt-5 text-xs text-slate-400 underline" data-testid="admin-login-back-home">
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}
